/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Workout_Logging_Kind_OpenInputs */

const en_us2_workout_logging_kind_open = /** @type {(inputs: Workout_Logging_Kind_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Set ${i?.n} type`)
};

const pt_br2_workout_logging_kind_open = /** @type {(inputs: Workout_Logging_Kind_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tipo da série ${i?.n}`)
};

const es_419_workout_logging_kind_open = /** @type {(inputs: Workout_Logging_Kind_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tipo de la serie ${i?.n}`)
};

const pt_pt2_workout_logging_kind_open = /** @type {(inputs: Workout_Logging_Kind_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tipo da série ${i?.n}`)
};

const fr_fr2_workout_logging_kind_open = /** @type {(inputs: Workout_Logging_Kind_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Type de la série ${i?.n}`)
};

const de_de2_workout_logging_kind_open = /** @type {(inputs: Workout_Logging_Kind_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Art von Satz ${i?.n}`)
};

const it_it2_workout_logging_kind_open = /** @type {(inputs: Workout_Logging_Kind_OpenInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tipo della serie ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Set {n} type" |
*
* @param {Workout_Logging_Kind_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_kind_open = /** @type {((inputs: Workout_Logging_Kind_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Kind_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_kind_open(inputs)
	if (locale === "es-419") return es_419_workout_logging_kind_open(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_kind_open(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_kind_open(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_kind_open(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_kind_open(inputs)
	return en_us2_workout_logging_kind_open(inputs)
});
export { workout_logging_kind_open as "workout-logging.kind_open" }